import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";
import StaticFooter from "./footer";
import StaticHeader from "./header";
import FooterLink from "./footerlink";

class PrivacyPolicy extends Component {

   componentDidMount(){
    
    document.querySelector('body').classList.remove('login_page');
    document.body.style.backgroundImage = "url('')";
   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
       
        <div className="static-page">    
        <StaticHeader />
        <section className="terms_conditions">
            <h2 className="text-center">{languagelist.Privacy1}</h2>
            <div className="container">
            <ul>
                <li><strong>1 l</strong> {languagelist.Privacy2}</li>
                <li><strong>2 l</strong> {languagelist.Privacy3}</li>
                <li><strong>3 l</strong> {languagelist.Privacy4}</li>
                <li><strong>4 l</strong> {languagelist.Privacy5}</li>
                <li><strong>5 l</strong> {languagelist.Privacy6}</li>
                <li><strong>6 l</strong> {languagelist.Privacy7}</li>
                <li><strong>7 l</strong> {languagelist.Privacy8}</li>
                <li><strong>8 l</strong> {languagelist.Privacy9}</li>
            </ul>

            <p><strong> {languagelist.Privacy10}</strong></p>

            <ul>
                <li>{languagelist.Privacy11}
                <ul>
                    <li><strong>{languagelist.Privacy12}</strong> {languagelist.Privacy13}</li>
                    <li><strong>{languagelist.Privacy14}</strong> {languagelist.Privacy15}</li>
                    <li><strong>{languagelist.Privacy16}</strong> {languagelist.Privacy17}</li>
                    <li><strong>{languagelist.Privacy18}</strong> {languagelist.Privacy19}</li>
                    <li><strong>{languagelist.Privacy20}</strong> {languagelist.Privacy21}</li>
                    <li><strong>{languagelist.Privacy22}</strong> {languagelist.Privacy23}</li>
                    <li><strong>{languagelist.Privacy24}</strong> {languagelist.Privacy25}</li>
                    <li><strong>{languagelist.Privacy26}</strong> {languagelist.Privacy27}</li>
                    <li><strong>{languagelist.Privacy28}</strong> {languagelist.Privacy29}</li>
                    <li><strong>{languagelist.Privacy30}</strong> {languagelist.Privacy31}</li>
                </ul>
                </li>
            </ul>

            <p><strong>{languagelist.Privacy32}</strong></p>

            <ul>
                <li><strong>{languagelist.Privacy33}</strong>{languagelist.Privacy34}</li>
                <li><strong>{languagelist.Privacy35}</strong> {languagelist.Privacy36}</li>
            </ul>

            <p><strong>{languagelist.Privacy37}</strong></p>

            <p>{languagelist.Privacy38}</p>
                
                
                </div>

            </section>



            <section className="panel_7 text-center">
                <div className="container">
                    <FooterLink />

                    <p> {languagelist.Staticfooter1}</p>
                </div>
            </section>

        <StaticFooter />

        </div>
      
      );
    }
  }
export default PrivacyPolicy;